/* eslint-disable */
import { node, icon } from "~/util/dom";
import { ICategoryItem } from "~/interfaces";
import { _ } from "~/i18n";
import { getIcon } from "~/util/providers/poiagg";
import { CONFIG } from "~/config";

export function createCategory(el, full:boolean = false, categories, moreClick:() => void, categoryClick:() => void): void {
	let header = node("div", { className: "header" });
	let title = node("h3", { textContent: _("fixedSuggest.category.title") });
	let rightPart = node("span", { className: "right-part" });
	let link = node("a", { href: "#", textContent: full ? _("close") : _("fixedSuggest.category.more") });
	link.setAttribute("data-log-ignore", "1");
	link.addEventListener("click", moreClick);
	rightPart.appendChild(link);
	header.appendChild(title);
	header.appendChild(rightPart);
	el.appendChild(header);
	full && el.append(node("p", {}, _("fixedSuggest.category.tip")))
	// polozky
	let content = node("div", { className: "content" });
	categories.forEach((i:ICategoryItem, n:number) => {
		content.appendChild(createCategoryItem(i, n, categoryClick));
	});
	el.appendChild(content);
};

function createCategoryItem(data:ICategoryItem, index:number, categoryClick:(e:Event, data:ICategoryItem, index:number) => void) {
	let categoryLink = node("a", { className: "category-item", href: `https://${CONFIG.BASE_URL}/?q=${encodeURIComponent(data.title)}&cat=1` });
	let imgHolder = node("span", { className: "img-holder" });
	let iconSrc = getIcon(data.poiTypeId);
	let iconImg = new Image();
	iconImg.crossOrigin = "anonymous";
	if (iconSrc) {
		iconImg.src = getIcon(data.poiTypeId);
		iconImg.setAttribute("srcset", `${getIcon(data.poiTypeId)} 1x, ${getIcon(data.poiTypeId, { scale: 2 })} 2x`);
	}
	else {
		iconImg = icon("pin");
		iconImg.crossOrigin = "anonymous";
	}
	let title = node("span", { className: "title", textContent: data.title });
	categoryLink.addEventListener("click", e => {
		categoryClick(e, data, index);
	});
	imgHolder.appendChild(iconImg);
	categoryLink.appendChild(imgHolder);
	categoryLink.appendChild(title);

	return categoryLink;
}
